export enum RiskAssessmentTypeCode {
  IncompleteActivity = 'riskassessment.type.incompleteactivity',
  SchedueledAppointment = 'riskassessment.type.schedueledappointment',
}

export const RiskAssessmentTypeCodeDescription: Record<
  RiskAssessmentTypeCode,
  string
> = {
  [RiskAssessmentTypeCode.IncompleteActivity]: 'Incomplete Activity',
  [RiskAssessmentTypeCode.SchedueledAppointment]: 'Scheduled Appointment',
};
